import { BottomNavigation, BottomNavigationAction, SvgIcon, WithStyles, withStyles } from '@material-ui/core';
// import SupportIcon from '@material-ui/icons/Help';
import PrivacyIcon from '@material-ui/icons/PermIdentity';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import About from './About';
import Contact from './Contact';
import ContextDrawer from './ContextDrawer';
import Privacy from './Privacy';
import Support from './Support';
const styles = {

};

interface IState {
	content?: React.ReactNode;
	open: boolean;
}

type Props = RouteComponentProps<{}> & WithStyles;

export class Footer extends React.Component<Props, IState> {
	constructor(props: Props, context?: any) {
		super(props, context);
		const { location } = this.props;
		let content;
		let open = false;
		switch (location.hash) {
			case '#privacy':
				content = <Privacy />;
				open = true;
				break;
			case '#contact':
				content = <Contact />;
				open = true;
				break;
			case '#support':
				content = <Support />;
				open = true;
				break;
			case "#about":
				content = <About />;
				open = true;
				break;
			default:
				break;
		}
		this.state = {
			content,
			open
		};
	}
	public render() {
		const { content, open } = this.state;
		console.log('footer render');
		return (
			<div>
				<ContextDrawer content={content} open={open} onOpen={this.onOpen} onClose={this.onClose} />
				<BottomNavigation style={{ position: 'fixed', bottom: '0px', width: '100%' }}>
					{/* <BottomNavigationAction label="About" icon={this.getNewtIndustriesIcon()} showLabel={true} onClick={this.onAboutClicked} hidden={true} disabled={true} /> */}
					<BottomNavigationAction label="Privacy" icon={<PrivacyIcon />} showLabel={true} onClick={this.onPrivacyClicked} />
					<BottomNavigationAction label="Contact" icon={this.getContactIcon()} showLabel={true} onClick={this.onContactClicked} />
					{/* <BottomNavigationAction label="Support" icon={<SupportIcon />} showLabel={true} onClick={this.onSupportClicked} /> */}
				</BottomNavigation>
			</div>
		)
	}
	// private onAboutClicked = () => {
	// 	console.log('about click');
	// 	this.setState({
	// 		content: <About />,
	// 		open: true
	// 	});
	// }	
	private onPrivacyClicked = () => {
		console.log('privacy click');
		this.setState({
			content: <Privacy />,
			open: true
		});
	}
	private onContactClicked = () => {
		console.log('contact click');
		this.setState({
			content: <Contact />,
			open: true
		});
	}
	// private onSupportClicked = () => {
	// 	console.log('support clicked');
	// 	this.setState({
	// 		content: <Support />,
	// 		open: true
	// 	});
	// }
	private onOpen = () => {
		this.setState({
			open: true
		});
	}
	private onClose = () => {
		this.setState({
			content: undefined,
			open: false
		})
	}
	private getContactIcon() {
		return (
			<SvgIcon>
				<path fill="currentColor" d="M20,0H4V2H20V0M4,24H20V22H4V24M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M12,6.75A2.25,2.25 0 0,1 14.25,9A2.25,2.25 0 0,1 12,11.25A2.25,2.25 0 0,1 9.75,9A2.25,2.25 0 0,1 12,6.75M17,17H7V15.5C7,13.83 10.33,13 12,13C13.67,13 17,13.83 17,15.5V17Z" />
			</SvgIcon>
		);
	}
	// private getNewtIndustriesIcon() {
	// 	return (
	// 		<SvgIcon viewBox={'0 0 174 174'}>
	// 			<g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,174.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
	// 				<path d="M0 870 l0 -870 870 0 870 0 0 870 0 870 -870 0 -870 0 0 -870z m1690 0 l0 -820 -820 0 -820 0 0 820 0 820 820 0 820 0 0 -820z" />
	// 				<path d="M130 870 l0 -730 245 0 c135 0 245 2 245 4 0 2 -30 33 -66 68 -82 78 -197 230 -246 323 -85 164 -127 334 -134 545 l-4 135 34 -102 c49 -143 96 -242 171 -354 258 -388 695 -619 1170 -619 l65 0 0 730 c0 642 -2 730 -15 730 -13 0 -15 -61 -15 -489 l0 -489 -47 -12 c-137 -36 -335 -19 -473 39 -174 74 -248 152 -291 306 -15 52 -19 218 -7 271 6 28 4 31 -25 42 -65 24 -87 107 -41 161 31 38 80 49 121 28 l29 -16 43 55 c23 30 54 62 67 70 13 9 24 20 24 25 0 5 -185 9 -425 9 l-425 0 0 -730z" />
	// 			</g>
	// 		</SvgIcon>
	// 	);
	// }
}

export default withRouter(withStyles(styles)(Footer));


// WEBPACK FOOTER //
// ./src/components/Footer.tsx